<div @fadeLeft *ngIf="show" class="float-menu-content">
    <div class="menu-header" [ngStyle]="{'background-color': headerColor}">
        <ng-content select="h5"></ng-content>
        <!-- <h5>Permissões</h5> -->
        <mmp5-mm-icons [icon]="['icon','icon-fechar']" (click)="close.emit(true)" class="pointer text-white"></mmp5-mm-icons>
    </div>
    <div class="content">
        <ng-content select="div"></ng-content>
    </div>
</div>
